const BUILD = "prod";

const APIURL =
  (BUILD === "dev" && process.env.REACT_APP_API_BASE_DEV) ||
  (BUILD === "test" && process.env.REACT_APP_API_BASE_TEST) ||
  (BUILD === "prod" && process.env.REACT_APP_API_BASE_PROD);

const API_URL_SOCKET =
  BUILD === "dev"
    ? process.env.REACT_APP_API_BASE_SOCKET_DEV
    : BUILD === "test"
      ? process.env.REACT_APP_API_BASE_SOCKET_TEST
      : process.env.REACT_APP_API_BASE_SOCKET_PROD;

console.log('APIURL: ========>', APIURL);
console.log('API_URL_SOCKET: ========>', API_URL_SOCKET);
console.log('API_URL_SOCKET_LIVE: ========>', API_URL_SOCKET);

export { APIURL, API_URL_SOCKET };
